/**
 * View component for /user-answers/:userAnswerId/update
 *
 * Updates a single userAnswer from a copy of the selcted userAnswer
 * as defined in the userAnswer reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as userAnswerActions from '../userAnswerActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import module components
import UserAnswerForm from '../components/UserAnswerForm.js.jsx';
import UserAnswerLayout from '../components/UserAnswerLayout.js.jsx';

// import userAnswer css modules
import userAnswerStyles from '../userAnswerModuleStyles.css';

class UpdateUserAnswer extends Base {
  constructor(props) {
    super(props);
    const { selectedUserAnswer, userAnswerMap } = this.props;
    this.state = {
      userAnswer: userAnswerMap[selectedUserAnswer.id] ? { ...userAnswerMap[selectedUserAnswer.id] } : {}
      // NOTE: we don't want to change the store, just make changes to a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(userAnswerActions.fetchSingleIfNeeded(match.params.userAnswerId))
  }

  componentWillReceiveProps(nextProps) {
    const { selectedUserAnswer, userAnswerMap } = nextProps;
    this.setState({
      userAnswer: userAnswerMap[selectedUserAnswer.id] ? { ...userAnswerMap[selectedUserAnswer.id] } : {}
      //we don't want to actually change the store's userAnswer, just use a copy
    })
  }

  _handleFormChange(e) {
    let newUserAnswerState = _.update( this.state.userAnswer, e.target.name, function() {
      return e.target.value;
    });
    this.setState({userAnswer :newUserAnswerState});
  }

  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(userAnswerActions.sendUpdateUserAnswer(this.state.userAnswer)).then((action) => {
      if(action.success) {
        history.push(`/user-answers/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { selectedUserAnswer, userAnswerMap } = this.props;
    const { userAnswer } = this.state;
    const isEmpty = (!userAnswer || userAnswer._id === null || userAnswer._id === undefined);
    return  (
      <UserAnswerLayout>
        <div className="flex">
          <section className="section">
            {isEmpty ?
              (selectedUserAnswer.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
              :
              <UserAnswerForm
                userAnswer={userAnswer}
                cancelLink={`/user-answers/${userAnswer._id}`}
                formTitle="Update User Answer"
                formType="update"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
              />
            }
          </section>
        </div>
      </UserAnswerLayout>
    )
  }
}

UpdateUserAnswer.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    selectedUserAnswer: store.userAnswer.selected
    , userAnswerMap: store.userAnswer.byId
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UpdateUserAnswer)
);



// WEBPACK FOOTER //
// modules/userAnswer/views/UpdateUserAnswer.js.jsx